import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface SortCaretProps {
  onSort: (d: string, asc: boolean) => void;
  order: "asc" | "desc" | undefined;
  field: string;
}

export default function SortCaret(props: SortCaretProps) {
  const { onSort, field, order } = props;
  return (
    <span
      className={"duke-sort fa-layers fa-fw"}
      onClick={(e) => {
        onSort(field, order ? order !== "asc" : false);
        e.stopPropagation();
      }}
    >
      <FontAwesomeIcon icon={"sort"}></FontAwesomeIcon>
      {order === "asc" && (
        <FontAwesomeIcon
          icon={"sort-up"}
          className={"active"}
        ></FontAwesomeIcon>
      )}
      {order === "desc" && (
        <FontAwesomeIcon
          icon={"sort-down"}
          className={"active"}
        ></FontAwesomeIcon>
      )}
    </span>
  );
}
